module.exports = __webpack_public_path__ + "static/media/Lima_summary.303a3519.pdf";